import React from 'react';
import { useHistory } from 'react-router-dom';
import BackIcon from '../../assets/icons/back-arrow.svg?react';
import Loader from '@/v2/components/Loader';
import { Heading } from '@/components/ui/shared/heading';
import { ChevronLeft } from 'lucide-react';
import InlineLoader from '@/components/shared/InlineLoader/InlineLoader';

const Page = ({ children, loading, error, styles }) => {
  const baseHeight = loading ? 'calc(100% - 157px)' : 'auto';
  const mobileHeight = 'calc(100% - 115px)';

  return (
    <div
      className={`relative pb-20 min-h-[calc(100%-65px)] md:min-h-[${mobileHeight}] md:pb-[70px] bg-white`}
      style={{ height: baseHeight, ...styles }}
    >
      {loading && <InlineLoader light={true} />}
      {!loading && !error && children}
      {error && (
        <div className="py-[70px] text-center text-[16px]">
          Atsiprašome įvyko nenumatyta klaida, bandykite dar kartą.{' '}
          <a href="/" className="hover:no-underline">
            Grįžti.
          </a>
        </div>
      )}
    </div>
  );
};

const Title = ({
  children,
  backUrl,
  backData,
  goBack,
  smallHeight,
  greyTheme,
}) => {
  const history = useHistory();

  const h1Color = greyTheme ? 'text-[#52585F]' : 'text-black';

  return (
    <div
      className={`flex items-start ${
        smallHeight ? 'my-0' : 'mt-20 mb-[50px]'
      } md:my-2`}
    >
      {(backUrl || goBack) && (
        <div
          className={`
            w-[50px] h-[${
              greyTheme ? '69px' : '60px'
            }] flex items-center cursor-pointer transition-all duration-150
            ${greyTheme ? 'self-center' : ''}
            md:w-[19px] md:mr-[12px] ${!greyTheme ? 'md:mt-[8px]' : ''}
            hover:opacity-50
          `}
          onClick={() =>
            backUrl ? history.push(backUrl, backData) : history.goBack()
          }
        >
          {/* <BackIcon className="transition-all duration-150 hover:translate-x-1" /> */}
          <ChevronLeft />
        </div>
      )}

      <Heading variant="2">{children}</Heading>
    </div>
  );
};

Page.Title = Title;

export default Page;
